import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [attempts, setAttempts] = useState(0);
  const [isPrepurchase, setIsPrepurchase] = useState(false);
  const maxAttempts = 5;

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const stripeSessionId = urlParams.get('session_id');
    const prepurchaseId = urlParams.get('prepurchase');

    if (!stripeSessionId) {
      navigate('/');
      return;
    }

    // Check if this is a prepurchase flow
    if (prepurchaseId) {
      setIsPrepurchase(true);
      localStorage.setItem('prepurchaseId', prepurchaseId);
      localStorage.setItem('hasPaid', 'true');
    }

    const checkPaymentStatus = async () => {
      try {
        const response = await axios.get(`${API}/checkout/status/${stripeSessionId}`);
        
        if (response.data.payment_status === 'paid') {
          setChecking(false);
          
          if (prepurchaseId) {
            // Prepurchase flow: redirect to upload page
            setTimeout(() => {
              navigate('/upload', { state: { paid: true, prepurchaseId } });
            }, 2000);
          } else {
            // Regular flow: redirect to upsell
            const creditSessionId = localStorage.getItem('creditSessionId') || stripeSessionId;
            setTimeout(() => {
              navigate('/upsell', { state: { sessionId: creditSessionId } });
            }, 2000);
          }
        } else if (attempts < maxAttempts) {
          setAttempts(attempts + 1);
          setTimeout(() => checkPaymentStatus(), 2000);
        } else {
          setChecking(false);
        }
      } catch (error) {
        console.error('Payment status check error:', error);
        if (attempts < maxAttempts) {
          setAttempts(attempts + 1);
          setTimeout(() => checkPaymentStatus(), 2000);
        }
      }
    };

    checkPaymentStatus();
  }, [location, navigate, attempts]);

  return (
    <div className="loading-container">
      <div className="loading-box">
        {checking ? (
          <>
            <div className="spinner" data-testid="success-spinner"></div>
            <div className="loading-text" data-testid="success-text">Verifying your payment...</div>
            <div className="loading-subtext">Please wait while we confirm your purchase</div>
          </>
        ) : (
          <>
            <div style={{ fontSize: 64, marginBottom: 24 }}>✓</div>
            <div className="loading-text" style={{ color: '#10b981' }}>Payment Successful!</div>
            <div className="loading-subtext">
              {isPrepurchase 
                ? "Redirecting to upload your credit report..." 
                : "Redirecting to your special offer..."}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SuccessPage;
